export const company = {
  legalName: 'KONSRI TECHNOLOGIES PRIVATE LIMITED',
  shortName: 'Konsri Technologies',
  cin: 'U63999TS2024PTC188525',
  email: 'info@konsritech.com',
  siteUrl: 'https://www.konsritech.com',
  description:
    'Konsri Technologies builds FinQ and offers product development, software, cloud, and data services.',
}

export const finq = {
  name: 'FinQ',
  url: 'https://finq.in',
  tagline: 'WhatsApp stock alerts for NSE & BSE',
  description:
    'FinQ is our AI-powered platform that sends real-time market alerts for your preferred stocks via WhatsApp — so you catch results, meetings, dividends, and orders the moment they land.',
  highlights: [
    'Real-time alerts delivered on WhatsApp',
    'Coverage across 7000+ NSE & BSE stocks',
    'Quarterly results, board meetings, dividends, and order announcements',
    'Free lifetime plan to get started',
  ],
}
